import { Spinner } from "@hightouch/htui";

import { PreworkspacePage } from "src/components/layout/preworkspace-page";
import { AuthenticatedRoute } from "src/components/router/authenticated-route";
import { NoContextOutlet } from "src/router";
import * as Workspaces from "./workspaces";
import * as WorkspacesNew from "./new";

export const WorkspacesLayout = () => {
  return (
    <PreworkspacePage title="Workspaces">
      <NoContextOutlet />
    </PreworkspacePage>
  );
};

export const routes = {
  path: "workspaces",
  element: <WorkspacesLayout />,
  children: [
    {
      index: true,
      element: (
        <AuthenticatedRoute loadingFallback={<Spinner size="lg" m="auto" />}>
          <Workspaces.Page />
        </AuthenticatedRoute>
      ),
    },
    {
      path: "new",
      element: (
        <AuthenticatedRoute loadingFallback={<Spinner size="lg" m="auto" />}>
          <WorkspacesNew.Page />
        </AuthenticatedRoute>
      ),
    },
  ],
};
